import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { ExternalAgent } from "../models/ExternalAgent";

export const useCreateExternalAgent = () => {
  const {
    data: isCreated,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const createExternalAgent = async (agent: ExternalAgent) => {
    await call("/admin/externalAgents", "POST", undefined, agent);
  };

  return {
    createExternalAgent,
    isCreated,
    isLoading,
    isFailed,
  };
};
